import { match } from 'ts-pattern'

import type { ConductorTask } from 'Automations/nodeDefinitions/conductor'

/**
 * Finds a task anywhere in a workflow, including inside fork branches, switch
 * cases and do-while bodies.
 */
export const findTaskByReferenceName = ({
  tasks,
  taskReferenceName
}: {
  tasks: ConductorTask[]
  taskReferenceName: string
}): ConductorTask | undefined =>
  flattenTasks(tasks).find(task => task.taskReferenceName === taskReferenceName)

/** Depth first, so a task always comes before the ones nested inside it. */
const flattenTasks = (tasks: ConductorTask[]): ConductorTask[] =>
  tasks.flatMap(task => [task, ...flattenTasks(nestedTaskLists(task).flat())])

const nestedTaskLists = (task: ConductorTask): ConductorTask[][] =>
  match(task)
    .with({ type: 'FORK_JOIN' }, forkJoinTask => forkJoinTask.forkTasks)
    .with({ type: 'SWITCH' }, switchTask => [
      ...Object.values(switchTask.decisionCases),
      switchTask.defaultCase
    ])
    .with({ type: 'DO_WHILE' }, doWhileTask => [doWhileTask.loopOver])
    .otherwise(() => [])
